import Vue from "vue";
import Router from "vue-router";
import Act2019 from "./router2019.js";
import Act2020 from "./router2020.js";
import ActScrm from "./routerScrm.js";
import ActLive from "./routerLive.js";
import Act2021 from "./router2021.js";
import CommonR from "./routerCommon";
import Act2022 from "./router2022.js";
import Act2023 from "./router2023.js";
import Act2024 from "./router2024.js";
import Act2025 from "./router2025.js";
import Act2026 from "./router2026.js";
import Actdmmeeting from "./routerdmmeeting.js";
import ActDaka from "./routerdaka.js";
Vue.use(Router);

const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => error);
};

var routerArray = [];

Act2019.map((item, index) => {
  routerArray.push(Object.assign({}, item));
});
Act2020.map((item, index) => {
  routerArray.push(Object.assign({}, item));
});
ActLive.map((item, index) => {
  routerArray.push(Object.assign({}, item));
});
ActScrm.map((item, index) => {
  routerArray.push(Object.assign({}, item));
});
Act2021.map((item, index) => {
  routerArray.push(Object.assign({}, item));
});
CommonR.map((item, index) => {
  routerArray.push(Object.assign({}, item));
});
Act2022.map((item, index) => {
  routerArray.push(Object.assign({}, item));
});
Act2023.map((item, index) => {
  routerArray.push(Object.assign({}, item));
});
Act2024.map((item, index) => {
  routerArray.push(Object.assign({}, item));
});
Act2025.map((item, index) => {
  routerArray.push(Object.assign({}, item));
});
Act2026.map((item, index) => {
  routerArray.push(Object.assign({}, item));
});
Actdmmeeting.map((item, index) => {
  routerArray.push(Object.assign({}, item));
});
ActDaka.map((item, index) => {
  routerArray.push(Object.assign({}, item));
});
export default new Router({
  mode: "history",
  routes: routerArray,
});
